import { render, staticRenderFns } from "./EngConsumablesTable.vue?vue&type=template&id=b35720e8&scoped=true"
import script from "./EngConsumablesTable.vue?vue&type=script&lang=js"
export * from "./EngConsumablesTable.vue?vue&type=script&lang=js"
import style0 from "./EngConsumablesTable.vue?vue&type=style&index=0&id=b35720e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35720e8",
  null
  
)

export default component.exports